import React, { Fragment } from 'react'
import { Marker as ReactMarker, InfoWindow, Circle } from 'react-google-maps'
import Tank from 'components/Page/Home/Tank'

interface IProps {
  loc: any
  disabled?: boolean
  onClick?: (tankId: string) => void
}

interface IState {
  isOpen: boolean
  showInfoIndex: number
}

class MarkerTracker extends React.PureComponent<IProps, IState> {
  static defaultProps = {
    onClick: () => { },
  }

  constructor(props: IProps) {
    super(props)
    this.state = ({
      isOpen: false,
      showInfoIndex: 0
    })
  }

  handleToggleOpen = () => {
    this.setState({
      isOpen: true
    })
  }

  handleToggleClose = () => {
    this.setState({
      isOpen: false
    })
  }

  showInfo(a) {
    this.setState({
      isOpen: true,
      showInfoIndex: a
    })
  }

  render() {
    const { loc, onClick } = this.props
    return (
      loc.map(function (location, i) {
        return (
          <Fragment>
            <ReactMarker key={i} position={{ lat: location.lat, lng: location.lng }} onClick={() => this.showInfo(i)}>
              {(this.state.isOpen && this.state.showInfoIndex === i) &&
                <InfoWindow onCloseClick={this.handleToggleClose}>
                  <div style={{ width: '300px' }}>
                    <Tank tank={location.tank} locationTimeStamp={location.datetime} onClick={() => onClick(location.tank.deviceID)} />
                  </div>
                </InfoWindow>
              }
            </ReactMarker>
            {loc.length == 1 && (<Circle
              defaultCenter={{
                lat: parseFloat(location.lat),
                lng: parseFloat(location.lng)
              }}
              radius={loc[0].tank.location.accuracy}
              options={{ strokeColor: "#F8F8F8", fillColor: "#D3D3D3" }}
            />)}
          </Fragment>

        )
      }, this)
    )

  }
}

export default MarkerTracker 